var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',{attrs:{"name":"PasswordRecovery","login-screen":""}},[_c('PasswordRecovery')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }